/* The settings (see settings.tsx), over the title screen. */

.settings {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(255, 246, 235, 0.55);
  backdrop-filter: blur(3px);
  z-index: 10;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: min(460px, calc(100vw - 32px));
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  padding: 18px 22px 20px;
  border-radius: 24px;
  background: var(--panel);
  border: 1px solid var(--line);
  box-shadow: 0 12px 40px rgba(120, 80, 50, 0.15);
  animation: rise-in 0.3s ease-out;
}

@keyframes rise-in {
  0% {
    opacity: 0;
    transform: translateY(10px) scale(0.96);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}

.heading {
  margin: 0;
  font-size: 20px;
  text-align: center;
}

.groupTitle {
  margin: 6px 0 -2px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: var(--ink-soft);
}

/* One setting: what it is on the left, how it is set on the right. */
.setting {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fffaf3;
}

.data .setting {
  border: none;
  background: none;
  padding: 0;
}

.data {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fffaf3;
}

.label {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.label b {
  font-size: 14px;
}

.label small {
  font-size: 11px;
  line-height: 1.5;
  color: var(--ink-soft);
}

label.setting {
  cursor: pointer;
}

/* Two choices joined, the one set filled in. */
.choice {
  display: flex;
  flex: none;
  padding: 3px;
  border-radius: 99px;
  background: var(--accent-soft);
}

.choice button {
  padding: 5px 12px;
  border: none;
  border-radius: 99px;
  background: none;
  font-size: 13px;
  font-weight: 700;
  color: var(--accent);
  cursor: pointer;
}

.choice button[aria-pressed="true"] {
  background: var(--accent);
  color: #fff;
  box-shadow: 0 2px 0 #c8693f;
}

/* A checkbox drawn as a sliding switch. */
.switch {
  flex: none;
  position: relative;
  width: 46px;
  height: 26px;
  margin: 0;
  border-radius: 99px;
  background: rgba(122, 86, 68, 0.2);
  appearance: none;
  cursor: pointer;
  transition: background 0.15s;
}

.switch::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(90, 58, 46, 0.3);
  transition: transform 0.15s;
}

.switch:checked {
  background: var(--mint);
}

.switch:checked::after {
  transform: translateX(20px);
}

.volume {
  flex: none;
  width: 120px;
  margin: 0;
  accent-color: var(--accent);
}

.switch:focus-visible,
.choice button:focus-visible {
  outline: 2px solid var(--mint);
  outline-offset: 2px;
}

.action {
  flex: none;
  padding: 6px 12px;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
  color: var(--ink);
  cursor: pointer;
}

.action:disabled {
  opacity: 0.4;
  cursor: default;
}

.data .setting + .setting {
  padding-top: 8px;
  border-top: 1px dashed var(--line);
  border-radius: 0;
}

.notice {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  color: var(--mint);
}

.notice[data-ok="false"] {
  color: #c0564c;
}

.clear {
  flex: none;
  padding: 6px 12px;
  border: 1px solid rgba(201, 92, 80, 0.4);
  border-radius: 10px;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
  color: #c0564c;
  cursor: pointer;
}

.clear:disabled {
  opacity: 0.4;
  cursor: default;
}

/* Clearing away, asked once more before it goes. */
.ask {
  padding: 10px 12px 12px;
  border: 1px solid rgba(201, 92, 80, 0.35);
  border-radius: 10px;
  background: #fff4f1;
}

.ask p {
  margin: 0 0 8px;
  font-size: 12px;
  line-height: 1.6;
}

.ask button {
  flex: 1;
}

.danger {
  border: none;
  border-radius: 10px;
  padding: 8px 0 7px;
  background: #d9695f;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 3px 0 #b04f47;
  transition: transform 0.1s, box-shadow 0.1s;
}

.danger:active {
  transform: translateY(2px);
  box-shadow: 0 1px 0 #b04f47;
}

.actions {
  margin-top: 4px;
}

.actions button {
  flex: 1;
}
